import React, { useEffect, useState } from "react";
import { twMerge } from "tailwind-merge";
import { NumPicker } from "./QuantiySelector";

interface QuantityCardProps {
  onChange?: (quantity: number) => void;
  title?: string;
  minQuantity?: number;
  className?: string;
  value?: number;
  disabled?: boolean;
}

const QuantityCard: React.FC<QuantityCardProps> = ({
  value,
  title,
  minQuantity = 0,
  onChange,
  className,
  disabled,
}) => {
  const a = React.useMemo(
    () => (value && value >= minQuantity ? value : minQuantity),
    [value, minQuantity],
  );
  const [qty, setQty] = useState<number>(a);
  useEffect(() => {
    setQty(a);
  }, [a]);

  useEffect(() => {
    if (value !== undefined && value !== qty && value >= minQuantity) {
      setQty(value);
    }
  }, [minQuantity, qty, value]);

  return (
    <div
      className={twMerge(
        "flex items-center justify-between rounded-[1rem] border border-[#DCDCDC] bg-white px-4 py-[0.875rem] sm:px-5 sm:py-[0.75rem]",
        className,
        disabled ? "opacity-50" : "",
      )}
    >
      {title && (
        <span className="text-sm font-semibold sm:text-base sm:leading-[1.625rem]">
          {title}
        </span>
      )}
      <NumPicker
        onChange={(newQty) => {
          setQty(newQty);
          onChange?.(newQty);
        }}
        disabled={disabled}
        minQuantity={minQuantity}
        qty={qty}
      />
    </div>
  );
};

export default QuantityCard;
